import { postJson } from "./http";

export interface TallyFetchJob {
  id: string;
  label: string;
  status: string;
  error: string | null;
}

export interface TallyConnectStatus {
  installer_url: string;
  enrolled: boolean;
  agent_label: string | null;
  pairing_expires_at: string | null;
  company_name: string | null;
  expected_company_name: string | null;
  company_matched: boolean;
  company_mismatch: boolean;
  create_company: boolean;
  company_created: boolean;
  create_error: string | null;
  gstin: string | null;
  gst_state: string | null;
  gst_registration_type: string | null;
  jobs: TallyFetchJob[];
  counts: {
    gl: number;
    customers: number;
    vendors: number;
    banks: number;
    currencies: number;
    duty: number;
  };
  ready: boolean;
}

interface StatusEnvelope {
  data: TallyConnectStatus;
}

export const fetchTallyStatus = async (publicId: string): Promise<TallyConnectStatus> =>
  (await postJson<StatusEnvelope>("/api/onboarding/tally/status", { public_id: publicId })).data;

export const retryTallyFetch = async (publicId: string): Promise<TallyConnectStatus> =>
  (await postJson<StatusEnvelope>("/api/onboarding/tally/retry", { public_id: publicId })).data;
